<template>
  <div class="bg-white h-full container">
    <div class="flex flex-col items-center justify-center p-4">
      <h1>{{ title }}</h1>
      <p>{{ subTitle }}</p>
    </div>
    <div class="w-full">
      <img :src="image" class="max-h75vh" />
    </div>
    <div v-html="htmlContent" class="py-4"></div>
  </div>
</template>
<style>
.max-h75vh {
  max-height: 75vh;
}
</style>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("cms", {
      page: "page",
    }),
    title() {
      return this.page.title;
    },
    subTitle() {
      return this.page.subTitle;
    },
    htmlContent() {
      return this.page.html;
    },
    image() {
      return `${this.$imageURL}/${this.page.image}`;
    },
  },
  methods: {
    async getPage() {
      // console.log(this.$route.params.id);
      await this.$store.dispatch("cms/getPage", this.$route.params.id);
      // await this.$store.dispatch("cms/getPage", this.$route.params.slug);
    },
  },
  mounted() {
    this.getPage();
  },
};
</script>
